{
  "title": "Death Ward",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level abjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "8 hours",
  "description": [
    "You touch a creature and grant it a measure of protection from death. The first time the target would drop to 0 hit points as a result of taking damage, the target instead drops to 1 hit point, and the spell ends. If the spell is still in effect when the target is subjected to an effect that would kill it instantaneously without dealing damage, that effect is instead negated against the target, and the spells ends."
  ],
  "spellLists": ["cleric", "paladin"]
}
